import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const About = () => {
  return (
    <>
      <Helmet>
        <title>About Us - Miranda Landa Services LLC | Business Capital Consulting</title>
        <meta name="description" content="Learn about Miranda Landa Services LLC, a trusted financial consulting company dedicated to helping businesses prepare for funding opportunities." />
      </Helmet>

      {/* Hero Section */}
      <section style={{
        background: 'linear-gradient(135deg, #059669 0%, #10b981 100%)',
        color: 'white',
        padding: '5rem 2rem',
        textAlign: 'center'
      }}>
        <div style={{maxWidth: '800px', margin: '0 auto'}}>
          <h1 style={{fontSize: '3rem', fontWeight: '800', marginBottom: '1.5rem'}}>
            About Miranda Landa Services LLC
          </h1>
          <p style={{fontSize: '1.3rem', opacity: 0.95, lineHeight: '1.6'}}>
            Your trusted partner in business capital consulting and strategic funding advisory
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section style={{padding: '5rem 2rem', background: 'white'}}>
        <div style={{maxWidth: '900px', margin: '0 auto'}}>
          <div style={{marginBottom: '4rem'}}>
            <h2 style={{fontSize: '2.5rem', fontWeight: '800', color: '#064e3b', marginBottom: '1.5rem'}}>
              Who We Are
            </h2>
            <p style={{fontSize: '1.1rem', color: '#4b5563', lineHeight: '1.8', marginBottom: '1.5rem'}}>
              Miranda Landa Services LLC is a trusted financial consulting company dedicated to helping businesses 
              prepare for funding opportunities. We specialize in business capital advisory services, providing 
              professional guidance to business owners who are exploring their financing options.
            </p>
            <p style={{fontSize: '1.1rem', color: '#4b5563', lineHeight: '1.8', marginBottom: '1.5rem'}}>
              Our mission is to make the funding process simple, transparent, and reliable. We work with verified 
              financial institutions and guide you in evaluating the right funding paths for your business goals.
            </p>
            <div style={{
              background: '#f0fdf4',
              padding: '2rem',
              borderRadius: '12px',
              borderLeft: '4px solid #10b981',
              marginTop: '2rem'
            }}>
              <p style={{fontSize: '1.1rem', color: '#065f46', fontWeight: '600', marginBottom: '1rem'}}>
                Important Disclosure:
              </p>
              <p style={{fontSize: '1rem', color: '#064e3b', lineHeight: '1.7'}}>
                We do not issue loans directly or make lending decisions. All financing is handled by the lenders 
                we connect you with. We are a consulting firm that provides advisory services only.
              </p>
            </div>
          </div>

          {/* Our Approach */}
          <div style={{marginBottom: '4rem'}}>
            <h2 style={{fontSize: '2.5rem', fontWeight: '800', color: '#064e3b', marginBottom: '2rem'}}>
              Our Approach
            </h2>
            <div style={{display: 'grid', gap: '2rem'}}>
              <div style={{
                background: '#f9fafb',
                padding: '2rem',
                borderRadius: '12px',
                display: 'flex',
                gap: '1.5rem',
                alignItems: 'flex-start'
              }}>
                <div style={{fontSize: '2.5rem', flexShrink: 0}}>🎯</div>
                <div>
                  <h3 style={{fontSize: '1.5rem', fontWeight: '700', color: '#059669', marginBottom: '0.75rem'}}>
                    Client-Focused Strategy
                  </h3>
                  <p style={{color: '#6b7280', lineHeight: '1.7'}}>
                    We take the time to understand your unique business situation, goals, and challenges. Every 
                    consultation is tailored to your specific needs and circumstances.
                  </p>
                </div>
              </div>

              <div style={{
                background: '#f9fafb',
                padding: '2rem',
                borderRadius: '12px',
                display: 'flex',
                gap: '1.5rem',
                alignItems: 'flex-start'
              }}>
                <div style={{fontSize: '2.5rem', flexShrink: 0}}>🤝</div>
                <div>
                  <h3 style={{fontSize: '1.5rem', fontWeight: '700', color: '#059669', marginBottom: '0.75rem'}}>
                    Transparent Process
                  </h3>
                  <p style={{color: '#6b7280', lineHeight: '1.7'}}>
                    We believe in complete transparency. You'll always know what to expect, what documents are needed, 
                    and what steps come next in your funding preparation journey.
                  </p>
                </div>
              </div>

              <div style={{
                background: '#f9fafb',
                padding: '2rem',
                borderRadius: '12px',
                display: 'flex',
                gap: '1.5rem',
                alignItems: 'flex-start'
              }}>
                <div style={{fontSize: '2.5rem', flexShrink: 0}}>✅</div>
                <div>
                  <h3 style={{fontSize: '1.5rem', fontWeight: '700', color: '#059669', marginBottom: '0.75rem'}}>
                    Verified Partnerships
                  </h3>
                  <p style={{color: '#6b7280', lineHeight: '1.7'}}>
                    We only work with reputable, verified financial institutions. Your business deserves to be 
                    connected with legitimate lenders who can provide real funding solutions.
                  </p>
                </div>
              </div>

              <div style={{
                background: '#f9fafb',
                padding: '2rem',
                borderRadius: '12px',
                display: 'flex',
                gap: '1.5rem',
                alignItems: 'flex-start'
              }}>
                <div style={{fontSize: '2.5rem', flexShrink: 0}}>📊</div>
                <div>
                  <h3 style={{fontSize: '1.5rem', fontWeight: '700', color: '#059669', marginBottom: '0.75rem'}}>
                    Expert Guidance
                  </h3>
                  <p style={{color: '#6b7280', lineHeight: '1.7'}}>
                    Our team has extensive experience in business financing and capital advisory. We provide 
                    professional insights to help you make informed decisions about your funding options.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* What We Do */}
          <div style={{marginBottom: '4rem'}}>
            <h2 style={{fontSize: '2.5rem', fontWeight: '800', color: '#064e3b', marginBottom: '2rem'}}>
              What We Do
            </h2>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
              gap: '1.5rem'
            }}>
              {[
                'Evaluate your business funding needs',
                'Prepare comprehensive documentation',
                'Assess funding readiness and feasibility',
                'Connect you with appropriate lenders',
                'Guide you through the application process',
                'Provide strategic financial planning advice'
              ].map((item, index) => (
                <div key={index} style={{
                  background: '#f0fdf4',
                  padding: '1.5rem',
                  borderRadius: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '1rem'
                }}>
                  <span style={{color: '#10b981', fontSize: '1.5rem', fontWeight: '800'}}>✓</span>
                  <span style={{color: '#064e3b', fontWeight: '600'}}>{item}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Why Choose Us */}
          <div style={{marginBottom: '4rem'}}>
            <h2 style={{fontSize: '2.5rem', fontWeight: '800', color: '#064e3b', marginBottom: '2rem'}}>
              Why Choose Miranda Landa Services
            </h2>
            <div style={{
              background: 'linear-gradient(135deg, #f0fdf4 0%, #d1fae5 100%)',
              padding: '3rem',
              borderRadius: '16px'
            }}>
              <div style={{display: 'grid', gap: '1.5rem'}}>
                <div style={{display: 'flex', gap: '1rem', alignItems: 'flex-start'}}>
                  <span style={{fontSize: '1.5rem'}}>💼</span>
                  <div>
                    <strong style={{color: '#064e3b', fontSize: '1.1rem'}}>Professional Expertise:</strong>
                    <span style={{color: '#065f46', marginLeft: '0.5rem'}}>
                      Years of experience in business capital consulting and financial advisory
                    </span>
                  </div>
                </div>
                <div style={{display: 'flex', gap: '1rem', alignItems: 'flex-start'}}>
                  <span style={{fontSize: '1.5rem'}}>🔒</span>
                  <div>
                    <strong style={{color: '#064e3b', fontSize: '1.1rem'}}>Confidential Service:</strong>
                    <span style={{color: '#065f46', marginLeft: '0.5rem'}}>
                      Your business information is handled with the utmost confidentiality and security
                    </span>
                  </div>
                </div>
                <div style={{display: 'flex', gap: '1rem', alignItems: 'flex-start'}}>
                  <span style={{fontSize: '1.5rem'}}>⚡</span>
                  <div>
                    <strong style={{color: '#064e3b', fontSize: '1.1rem'}}>Efficient Process:</strong>
                    <span style={{color: '#065f46', marginLeft: '0.5rem'}}>
                      Streamlined consultation and preparation process to save you time
                    </span>
                  </div>
                </div>
                <div style={{display: 'flex', gap: '1rem', alignItems: 'flex-start'}}>
                  <span style={{fontSize: '1.5rem'}}>🎯</span>
                  <div>
                    <strong style={{color: '#064e3b', fontSize: '1.1rem'}}>Customized Solutions:</strong>
                    <span style={{color: '#065f46', marginLeft: '0.5rem'}}>
                      Every business is unique, and we tailor our approach to your specific situation
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section style={{
        background: 'linear-gradient(135deg, #064e3b 0%, #059669 100%)',
        color: 'white',
        padding: '4rem 2rem',
        textAlign: 'center'
      }}>
        <div style={{maxWidth: '700px', margin: '0 auto'}}>
          <h2 style={{fontSize: '2.5rem', fontWeight: '800', marginBottom: '1.5rem'}}>
            Let's Discuss Your Funding Goals
          </h2>
          <p style={{fontSize: '1.2rem', marginBottom: '2rem', opacity: 0.95}}>
            Schedule a consultation with our expert team today
          </p>
          <Link to="/contact" style={{
            background: 'white',
            color: '#059669',
            padding: '1.25rem 3rem',
            borderRadius: '50px',
            fontWeight: '700',
            fontSize: '1.2rem',
            display: 'inline-block',
            boxShadow: '0 10px 30px rgba(0,0,0,0.3)'
          }}>
            Contact Us Now
          </Link>
        </div>
      </section>
    </>
  );
};

export default About;
